// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xCoveoState } from "@eisinc/App/CoveoConnector/Store/Reducers";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchSetFilterQuery,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";

export const CoveoSendTracking: typeof DispatchSetFilterQuery = props => {
    const state = props.getState() as xCoveoState;

    if (state.xCoveo.trackCoveo && (props.parameter as any).coveoClearAll) {
        props.dispatch({
            type: "xCoveo/setFacetClearAllTriggered",
            facetClearAllTriggered: true,
        } as any);
    }
};

addToEndOfChain(chain, CoveoSendTracking);
